import React, { useState } from 'react'
import { Form, Input, Button, Select, Spin } from 'antd'
import ApiConfig from '../../../services/ApiConfig'
import { getDateFormat, tcblEmailList, pdexEmailList, recipientArray } from "../../../utils";
import apiFormDataClient from '../../../services/axios-formdata'
import apiClient from '../../../services/axios';
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
// import PageLoader from "../../../components/page-loader";

const Option = Select

const AddCampaign = ({ onFinish, setCustomEmail, customEmail }) => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showEmailField, setshowEmailField] = useState(false);
  const [showEmailCount, setshowEmailCount] = useState(false);
  const [disableEmail, setdisableEmail] = useState(true);
  const [loadedImage, setloadedImage] = useState(null);
  const [playersCount, setplayersCount] = useState(null);
  const [currentRecipient, setcurrentRecipient] = useState(null);
  const [isDraftDocs, setisDraftDocs] = useState(false);
  const [currentDate] = useState(getDateFormat({ date: new Date(), format: "ddd, MMM DD, YYYY" }));

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const text = draftToHtml(convertToRaw(editorState?.getCurrentContent()))

  const imageUploadCallback = async (values) => {
    const formdata = new FormData();
    formdata.append('promotion_image', values);
    try {
      // setLoading(true);
      const response = await apiFormDataClient.post(ApiConfig.website.savePromotionImage, formdata);
      setloadedImage(response?.data?.imagePath)
      return new Promise((resolve, reject) => {
        resolve({ data: { link: response?.data?.imagePath } });
      })
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
    }
  }

  const onFinishApiCall = (values) => {
    const formdata = new FormData();
    formdata.append('date', currentDate);
    formdata.append('subject', values.subject);
    formdata.append('editor', text);
    formdata.append('recipient', currentRecipient);
    formdata.append('deleting_image_url', loadedImage);
    formdata.append('is_draft', isDraftDocs);
    formdata.append('customEmail', customEmail);
    onFinish(formdata)
    // form.resetFields();
  }



  const onValuesChange = (changedValues) => {
    if(changedValues?.email){
      setCustomEmail([...changedValues?.email])
    }
    if (changedValues?.recipient === 1) {
      setcurrentRecipient(changedValues?.recipient)
      setshowEmailCount(true)
      setshowEmailField(false)
      loadUsers('player');
    } else if (changedValues?.recipient === 2) {
      setcurrentRecipient(changedValues?.recipient)
      setshowEmailField(true)
      setshowEmailCount(false)
      form.setFieldsValue({
        email: tcblEmailList,
      })
    }
    else if (changedValues?.recipient === 3) {
      setcurrentRecipient(changedValues?.recipient)
      setshowEmailField(true)
      setshowEmailCount(false)
      form.setFieldsValue({
        email: pdexEmailList,
      })
    }
    else if (changedValues?.recipient === 4) {
      setcurrentRecipient(changedValues?.recipient)
      setshowEmailField(true)
      setshowEmailCount(false)
      setdisableEmail(false)
      form.setFieldsValue({
        email: [],
      })
    }

  }

  const loadUsers = async (role) => {
    setLoading(true);
    const { data } = await apiClient.get(`${ApiConfig.userInfo.count}?role=${role}`)
    setplayersCount(data?.count)
    form.setFieldsValue({
      count: data?.count,
    })
    setLoading(false);
  }

  console.log("currentRecipient", currentRecipient)
  console.log("loading", loading)


  return (
    <>
      {/* {loading && <PageLoader />}
      {!loading && <> */}
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinishApiCall}
        onValuesChange={onValuesChange}
      >

        <Form.Item
          name="recipient"
          label="Recipient"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Select
            placeholder="Select a recipient"
            optionFilterProp="children"
          >
            {recipientArray?.map((mval, index) => (
              <Option key={mval?.value} value={mval?.value}>{mval?.label}</Option>
            ))}
          </Select>
        </Form.Item>
        {showEmailField && (
          <>
            <Form.Item
              name="email"
              label="Email Address"
            >
              <Select placeholder="Enter a email address" mode="tags" disabled={disableEmail}/>
            </Form.Item>
          </>
        )}
        {showEmailCount && (
          <>
            <Form.Item
              name="count"
              label="Player Email"
            >
              {!!playersCount ? <Input placeholder="Enter a email address" disabled /> : <div style={{ textAlign: "center" }}><Spin /></div>}
            </Form.Item>
          </>
        )}
        <Form.Item
          name="subject"
          label="Subject"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input placeholder="Enter a subject" />
        </Form.Item>
        <Form.Item
          name="editor"
          label="Text Editor"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Editor
            initialEditorState={editorState}
            editorState={editorState}
            onEditorStateChange={setEditorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            wrapperStyle={{ width: '100%', height: '60vh', border: "1px solid #d9d9d9" }}
            toolbar={{
              image: {
                uploadCallback: imageUploadCallback,
                previewImage: true,
              },
            }}
          />
        </Form.Item>
        <div className="form-footer">
          <Button type="primary" htmlType="submit" onClick={() => setisDraftDocs(true)}>Save</Button>
          &nbsp;&nbsp;&nbsp;
          <Button type="primary" htmlType="submit">Send</Button>
        </div>
      </Form>
      {/* </>
      } */}
    </>
  )
}
export default AddCampaign
